module.exports = __webpack_public_path__ + "static/img/rocket.c1d0b16.png";


//////////////////
// WEBPACK FOOTER
// ./static/rocket.png
// module id = xTTs
// module chunks = 1